export default __webpack_public_path__ + "static/media/2021-propuestas-no-promesas.9390b059.svg";